// Copyright (c) 2021 WiseTime. All rights reserved.

import { Observable, of } from "rxjs"
import { Action } from "redux"
import { catchError, filter, map, mergeMap } from "rxjs/operators"
import { create } from "@bufbuild/protobuf"
import { t } from "@lingui/macro"
import * as Slice from "../slice"
import * as UserContextSlice from "../../user-context/slice"
import { showSnackBar } from "../../snackbar/actions"
import { executor, userCuesService } from "../../../app/rpc"
import { ListUserCuesRequestSchema, ListUserCuesResponse } from "../../../generated/wisetime/user/cues/v4/user_cues_pb"

type ListUserCuesRpc = () => Observable<ListUserCuesResponse>

export const listUserCues = (listUserCuesRpc: ListUserCuesRpc) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(UserContextSlice.setUserDetails.match),
      mergeMap(() => listUserCuesRpc().pipe(
        map(Slice.setUserCuesList),
        catchError(_ => of(showSnackBar({
          message: t({
            id: "msg_get_user_cues_failed",
            message: "Failed to get user cues. You can ignore this error."
          }),
          messageType: "ERROR",
        }))),
      )),
    )

const listUserCuesRpc = (): Observable<ListUserCuesResponse> =>
  executor(() => userCuesService.listUserCues(create(ListUserCuesRequestSchema, {})))

export default listUserCues(listUserCuesRpc)
